import React from 'react'; // Global States for faster scheduling

import { useStore } from "../../contexts/store";
export const Header = () => {
  const {
    state
  } = useStore();
  const {
    readOnly
  } = state;
  return /*#__PURE__*/React.createElement("div", {
    className: "overview-title"
  }, /*#__PURE__*/React.createElement("h4", null, readOnly ? 'Scheduling' : 'Availabilities'), readOnly ? /*#__PURE__*/React.createElement("div", {
    className: "overview-title-description"
  }, "This window lets you Schedule by picking any slot or Schedule after adding availabilities (To add availability please go to the Availability window)", /*#__PURE__*/React.createElement("br", null), "To Schedule Now - Pick any slot without the need to add availability and click on confirm or create zoom meeting") : /*#__PURE__*/React.createElement("div", {
    className: "overview-title-description"
  }, "This window only lets you add Availabilities (To schedule please go back to schedule window)", /*#__PURE__*/React.createElement("br", null), "Add Client and Expert Availabilities to the day view or use the Availability wizard to add multiple slots"));
};